/**
 * Scrolls the results table to the load row with the given row number and
 * flashes the global-search highlight on it. Used by chat "#123" load
 * references. No-op if the row isn't currently rendered (filtered out,
 * archived, other tab).
 */
export const focusLoadRow = (rowNumber: number): void => {
    // LoadsTable rows expose the backend row number via data-row-number
    // (LoadRow.tsx); the legacy agentic summary rows use data-row.
    const row = document.querySelector(`tr[data-row-number="${rowNumber}"], tr[data-row="${rowNumber}"]`) as HTMLElement | null
    if (!row) return
    row.scrollIntoView({ behavior: 'smooth', block: 'center' })
    // Retrigger the flash animation even if the class is still on from a prior click.
    row.classList.remove('global-search-highlight')
    void row.offsetWidth
    row.classList.add('global-search-highlight')
    window.setTimeout(() => row.classList.remove('global-search-highlight'), 3000)
}
